import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import {
    CommonFilterModel,
    CommonPaginatorResourceService,
    CommonParams
} from '@/api/resources/common/shared/models/common.models'
import { AppliedBillableConceptEntityType } from '@/api/services/billing/applied-billable-concept/billing-applied-billable-concept.dto'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import { getFilterModelByEntity } from '@/components/valuable-concepts-modal/shared/helpers/helpers'

export class CommonDatasourceValuableConceptsModal<T> extends PaginatorLaboratoryDatasource<T> {
    private readonly entityType: AppliedBillableConceptEntityType
    private readonly entityId: number
    private readonly accountingUnitId: number

    constructor(service: CommonPaginatorResourceService<T>, laboratoryId: number, entityType: AppliedBillableConceptEntityType, entityId: number, accountingUnitId: number) {
        super(service, laboratoryId)
        this.entityId = entityId
        this.entityType = entityType
        this.accountingUnitId = accountingUnitId
    }

    protected fetchData(filterModel: CommonFilterModel, params: CommonParams): Promise<IResponseAgGrid<T>> {
        if (!this.service) {
            throw new Error('undefined service')
        }
        const _filterModel: CommonFilterModel =
            getFilterModelByEntity(
                filterModel,
                this.entityType,
                this.accountingUnitId,
                this.entityId)
        return this.service.paginator(_filterModel, params, this.laboratoryId)
    }
}
